export enum WatcherState {
  SEND_TO_SALE = "SEND_TO_SALE",
  PROMPT_FOR_EMAIL = "PROMPT_FOR_EMAIL",
  EMAIL_EXISTS = "EMAIL_EXISTS",
  SALE_NOT_FOUND = "SALE_NOT_FOUND",
  INVALID_VERIFICATION = "INVALID_VERIFICATION",
  INVALID_EMAIL = "INVALID_EMAIL",
  ERROR = "ERROR",
  JWT_REFRESH_REQUIRED = "JWT_REFRESH_REQUIRED",
}

export enum ViewMode {
  DEFAULT = "DEFAULT",
  RING_SELLING_BY_PRICE = "RING_SELLING_BY_PRICE",
  RING_SELLING_BY_WEIGHT = "RING_SELLING_BY_WEIGHT",
  RING_SELLING_BY_PRICE_THEN_WEIGHT = "RING_SELLING_BY_PRICE_THEN_WEIGHT",
  RING_SELLING_BRIEF_BY_PRICE = "RING_SELLING_BRIEF_BY_PRICE",
  RING_SELLING_BRIEF_BY_WEIGHT = "RING_SELLING_BRIEF_BY_WEIGHT",
  RING_SELLING_BY_WEIGHT_WITH_BUYER_AND_BUYER_WAY = "RING_SELLING_BY_WEIGHT_WITH_BUYER_AND_BUYER_WAY",
  RING_SELLING_BY_WEIGHT_WITH_BUYER_AND_BUYER_WAY_FOR_DRAFTING_INFORMATION = "RING_SELLING_BY_WEIGHT_WITH_BUYER_AND_BUYER_WAY_FOR_DRAFTING_INFORMATION",
  RING_SELLING_BRIEF_BY_PRICE_THEN_WEIGHT = "RING_SELLING_BRIEF_BY_PRICE_THEN_WEIGHT",
  BIG_SCREEN = "BIG_SCREEN",
  SALE_PREVIEW = "SALE_PREVIEW",
  ON_SCALES = "ON_SCALES",
  ON_SCALES_DETAILED = "ON_SCALES_DETAILED",
  LAST_WEIGHED = "LAST_WEIGHED",
  LAST_WEIGHED_DETAILED = "LAST_WEIGHED_DETAILED",
  STUD_WATCHER_WITH_VENDOR = "STUD_WATCHER_WITH_VENDOR",
  STUD_WATCHER_WITH_BUYER_WAY = "STUD_WATCHER_WITH_BUYER_WAY",
  STUD_WATCHER_WITH_BUYER_WAY_AND_VENDOR = "STUD_WATCHER_WITH_BUYER_WAY_AND_VENDOR",
}

export const ViewModeConfig = {
  [ViewMode.DEFAULT]: {
    label: "Default",
    isPublic: true,
  },
  [ViewMode.RING_SELLING_BY_PRICE]: {
    label: "Ring ($)",
    isPublic: true,
  },
  [ViewMode.RING_SELLING_BY_WEIGHT]: {
    label: "Ring (kg)",
    isPublic: true,
  },
  [ViewMode.RING_SELLING_BY_WEIGHT_WITH_BUYER_AND_BUYER_WAY]: {
    label: "Ring (Kg) Detailed",
    isPublic: true,
  },
  [ViewMode.RING_SELLING_BY_WEIGHT_WITH_BUYER_AND_BUYER_WAY_FOR_DRAFTING_INFORMATION]:
    {
      label: "Ring (Kg) Detailed - Drafting Information",
      isPublic: true,
    },
  [ViewMode.RING_SELLING_BY_PRICE_THEN_WEIGHT]: {
    label: "Ring (kg, $)",
    isPublic: true,
  },
  [ViewMode.RING_SELLING_BRIEF_BY_PRICE]: {
    label: "Ring Brief ($)",
    isPublic: true,
  },
  [ViewMode.RING_SELLING_BRIEF_BY_WEIGHT]: {
    label: "Ring Brief (kg)",
    isPublic: true,
  },
  [ViewMode.RING_SELLING_BRIEF_BY_PRICE_THEN_WEIGHT]: {
    label: "Ring Brief (kg, $)",
    isPublic: true,
  },
  [ViewMode.BIG_SCREEN]: {
    label: "Big Screen",
    isPublic: true,
  },
  [ViewMode.SALE_PREVIEW]: {
    label: "Sale Preview",
    isPublic: true,
  },
  [ViewMode.STUD_WATCHER_WITH_VENDOR]: {
    label: "Stud Watcher w/Vendor",
    isPublic: false,
  },
  [ViewMode.STUD_WATCHER_WITH_BUYER_WAY_AND_VENDOR]: {
    label: "Stud Watcher w/Account and Vendor",
    isPublic: false,
  },
  [ViewMode.STUD_WATCHER_WITH_BUYER_WAY]: {
    label: "Stud Watcher w/Account",
    isPublic: false,
  },
  [ViewMode.ON_SCALES]: {
    label: "On Scales",
    isPublic: false,
  },
  [ViewMode.ON_SCALES_DETAILED]: {
    label: "On Scales (Detailed)",
    isPublic: false,
  },
  [ViewMode.LAST_WEIGHED]: {
    label: "Last Weighed",
    isPublic: false,
  },
  [ViewMode.LAST_WEIGHED_DETAILED]: {
    label: "Last Weighed (Detailed)",
    isPublic: false,
  },
} as const satisfies Record<ViewMode, { label: string; isPublic: boolean }>;
